/*
  Quiz Result — live discount bar (Pause Rituals)
  Tracks the REAL cart quantity (cart.item_count) and drives the "Prefer to pick & choose?"
  progress bar: fill (scaleX), tier nodes (radio dots), and the "Add N more for X% off" label.
  Tiers come from data-tier* on [data-qrp-cartbar] and should mirror a Shopify automatic
  discount (Buy N items → X% off). Refreshes on load + after any add-to-cart (pr:cart-added).
*/
(function () {
  function plural(n) { return n === 1 ? 'product' : 'products'; }

  function labelFor(count, t1n, t1p, t2n, t2p) {
    if (t1n && count < t1n) return 'Add ' + (t1n - count) + ' more ' + plural(t1n - count) + ' to get ' + t1p + '% off 🎉';
    if (t2n && count < t2n) return 'Add ' + (t2n - count) + ' more ' + plural(t2n - count) + ' to get ' + t2p + '% off 🎉';
    var pct = (t2n && count >= t2n) ? t2p : (t1n && count >= t1n ? t1p : 0);
    return pct > 0 ? "You've unlocked " + pct + '% off 🎉' : 'Add a few items to unlock a discount';
  }

  function update(count) {
    document.querySelectorAll('[data-qrp-cartbar]').forEach(function (bar) {
      var t1n = parseInt(bar.dataset.tier1Items, 10) || 0;
      var t1p = parseInt(bar.dataset.tier1Pct, 10) || 0;
      var t2n = parseInt(bar.dataset.tier2Items, 10) || 0;
      var t2p = parseInt(bar.dataset.tier2Pct, 10) || 0;
      var maxN = Math.max(t1n, t2n, 1);
      var ratio = Math.min(count / maxN, 1);

      var fill = bar.querySelector('[data-qrp-fill]');
      if (fill) fill.style.transform = 'scaleX(' + ratio + ')';

      var m1 = t2n ? Math.round((t1n / maxN) * 100) : 50;
      bar.querySelectorAll('[data-qrp-node="1"]').forEach(function (n) {
        n.style.left = m1 + '%';
        n.classList.toggle('is-reached', !!(t1n && count >= t1n));
      });
      bar.querySelectorAll('[data-qrp-node="2"]').forEach(function (n) {
        n.style.left = '100%';
        n.classList.toggle('is-reached', !!(t2n && count >= t2n));
      });

      var label = bar.querySelector('[data-qrp-label]');
      if (label) label.textContent = labelFor(count, t1n, t1p, t2n, t2p);
    });
  }

  function refresh() {
    if (!document.querySelector('[data-qrp-cartbar]')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { update(c.item_count || 0); })
      .catch(function () {});
  }

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);

  document.addEventListener('pr:cart-added', refresh);      // our add-to-cart (pdp-layer.js)
  document.addEventListener('shopify:section:load', refresh); // theme editor re-render
})();
